export default __webpack_public_path__ + "static/media/close.d7169d19.svg";